// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import { MonolithImageSizeFragmentDoc } from '../../monolithImageSize.fragment.generated';
export const ThreeSixtyFragmentDoc = `
    fragment threeSixty on GenericImage {
  url
  sizes(names: [W250, W320, W480, W640, W768, W1024, W1920, W2560]) {
    ...monolithImageSize
  }
}
    `;